export { PasswordInput, type PasswordInputProps } from './password-input';
